import React from 'react';
import { h } from '@app/helpers/translationHelper'
import Videos from './Videos'

const Mission = () => {
  return (
    <div className="section">
      <div className="grid grid--xl-2">
        <div>
          <h4 className="f--white">
            { I18n.t('landing.mission_1') }
          </h4>
          <p className="f--md f--white mt-gutter-m mb-2"
             dangerouslySetInnerHTML={ h('landing.mission_info_1') }
          />
        </div>

        <Videos />
      </div>
    </div>
  )
}

export default Mission;
